module.exports = __webpack_public_path__ + "img/instagram.73ee1cc.svg";